<div class="welcome-wrapper">
  <div class="welcome-header flex justify-content-center align-items-center py-2">
    <img src="assets/images/LincSell-White_Logo.svg" alt="LincSell logo">
  </div>

  <div class="welcome-body py-3 flex flex-column justify-content-center main">
    <div class="flex text-align-center f-24 welcome-copy">
      <div class="w-full">
        <div class="title py-2">
          Welcome&nbsp;<b>{{_global?.userInfo?.displayName}}!</b>
        </div>

        <p class="f-14">
          Thank you for choosing Lincsell to bring your business online.<br> We're dedicated to helping you
          establish a strong online presence, and reach customers everywhere.
        </p>
      </div>
    </div>

    <p-carousel class="welcome-carousel" [value]="dataList" [autoplayInterval]="5000" [circular]="true"
      [showNavigators]="false" [responsiveOptions]="responsiveOptions" [numVisible]="1" [numScroll]="1">
      <ng-template let-item pTemplate="item">
        <div class="flex justify-content-center my-3 responsive-carousel-item">
          <div class="flex justify-content-center align-items-center text-align-center flex-column carousel-card">
            <span class="img py-3" [style.background-image]="'url(' + item?.imageUrl + ')'">
            </span>
            <span class="second-title py-3">
              <b class="f-16">{{item.title}}</b>
            </span>
            <div class="f-14">
              {{item.description1}}
            </div>
            <div class="f-14">
              {{item.description2}}
            </div>
          </div>
        </div>
      </ng-template>
    </p-carousel>

    <div class="flex justify-content-center align-items-center py-1">
      <span class="button cursor-pointer" (click)="goTOHome()">
        Setup my Store
      </span>
    </div>
  </div>
</div>
